import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: []
    ,moduleRights:[]
    ,appName:  JSON.stringify(require('../package.json').name) || 'appName'
    ,appVersion:  JSON.stringify(require('../package.json').version) || '0'
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload.user
    }
    ,getUser: state => {
      return state.user
    }
    ,setModuleRights (state, payload) {
      state.moduleRights = payload.user
    }
    ,getModuleRights: state => {
      return state.moduleRights
    }
  },
  actions: {},
});
